import axios from 'axios'
import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import { HOST } from '@/http/config'

// 列表
export function getFireEquipmentlist(params) {
  return get(`${HOST}basis-fire-equipment/list`, params)
}
// 根据id删除
export function delFireEquipment(params) {
  return del(`${HOST}basis-fire-equipment/delete`, params)
}
// 详情
export function getFireEquipmentDetails(params) {
  return get(`${HOST}basis-fire-equipment/get`, params)
}
// 新增
export function saveFireEquipment(params) {
  return post(`${HOST}basis-fire-equipment/save`, params)
}
// 修改
export function updateFireEquipment(params) {
  return post(`${HOST}basis-fire-equipment/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-fire-equipment-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-fire-equipment-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-fire-equipment/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/fireEquipment/api.js